import { useSearchParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';

const useSteps = (maxSteps = 3, initialStep = 1) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const queryStep = Number(searchParams.get('step'));
  const [currentStep, setStep] = useState<number>(
    queryStep && queryStep >= 1 && queryStep <= maxSteps ? queryStep : initialStep || 1,
  );

  useEffect(() => {
    if (queryStep !== currentStep) {
      setSearchParams({ step: currentStep.toString() });
    }
  }, [currentStep, queryStep, setSearchParams]);

  const nextStep = useCallback(() => {
    setStep((prev) => (prev <= maxSteps ? prev + 1 : prev));
  }, [maxSteps]);

  const prevStep = useCallback(() => {
    setStep((prev) => (prev > 1 ? prev - 1 : prev));
  }, []);

  return { currentStep, nextStep, prevStep };
};

export default useSteps;
